module.exports = __webpack_public_path__ + "img/app_assets_img_mastercard.12c7b897.svg";